var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvaliationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 11.21L21.7999 14.03C21.9899 14.42 22.4999 14.79 22.9299 14.87L25.48 15.29C27.11 15.56 27.49 16.74 26.32 17.92L24.3299 19.91C23.9999 20.24 23.81 20.89 23.92 21.36L24.4899 23.82C24.9399 25.76 23.9 26.52 22.19 25.5L19.7999 24.08C19.3699 23.82 18.65 23.82 18.22 24.08L15.8299 25.5C14.1199 26.51 13.0799 25.76 13.5299 23.82L14.1 21.36C14.21 20.9 14.02 20.25 13.69 19.91L11.7 17.92C10.53 16.75 10.91 15.57 12.54 15.29L15.0899 14.87C15.5199 14.8 16.03 14.42 16.22 14.03L17.63 11.21C18.38 9.68 19.62 9.68 20.39 11.21Z",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 11H7",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 25H7",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 18H7",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliationsIcon);
export default __webpack_public_path__ + "static/media/avaliations-icon.550eba78e8703bf4af83076f0393bb29.svg";
export { ForwardRef as ReactComponent };